import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import UserDefaultAvatar from "assets/img/user.svg";
import DefaultTeamAvatar from "assets/img/HandsColorAvatar.jpeg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomButton from "components/CustomButton";
import TeamStatsDialog from "components/TeamStatsDialog";
import InviteTeamMember from "components/InviteTeamMember";
import LazyLoadImage from "components/LazyLoadImage";


import {
  faUserPlus,
  faListUl,
  faInfoCircle,
  faChartBar,
} from "@fortawesome/free-solid-svg-icons";

const styles = {
  teamContent: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  },
  teamName: {
    width: "calc(100% - 20px)",
  },
  topicName: {
    width: "calc(100% - 20px)",
  },
};

export default ({ team, memberCount = 4 }) => {
  const classes = styles;
  const [teamState, setTeamState] = useState({});
  const svgStyle = {
    width: "16px",
  };
  const [role] = useState({ 4: "Member", 3: "Admin", 2: "Super Admin" });

  useEffect(() => {
    const users = [...(team?.users || [])];

    users.length = memberCount;

    setTeamState({
      ...team,
      users,
    });
  }, [team, memberCount]);

  return (
    <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6 col-12 teamCard">
      <div className="t-single-card text-center">
        <div style={{ position: "relative" }}>
          <LazyLoadImage
            style={{
              maxHeight: "150px",
              height: "100%",
              minHeight: "150px",
              objectFit: "cover",
            }}
            image={teamState?.avatar ?? DefaultTeamAvatar}
            key={teamState?.id}
            alt={"teamImage"}
            imageClassName={"t-cover br-6"}
            imageWrapperClassName={"t-cover br-6"}
          />
          <img
            src={teamState?.rank?.mini_icon}
            alt="Badge"
            style={{
              position: "absolute",
              bottom: "-1px",
              right: "-1px",
              width: "30px",
              height: "auto",
              borderRadius: "11px",
            }}
          />
        </div>
        <div className="teams-boxes">
          <div className="t-profile">
            <Link
              style={{ color: "#575F6B" }}
              to={`/profile/${teamState?.manager?.id}`}
            >
              {teamState?.manager?.avatar && (
                <LazyLoadImage
                  image={teamState?.manager?.avatar}
                  key={teamState?.manager?.id}
                  alt={"user-name"}
                  imageClassName={"t-profile-pic rounded-circle"}
                />
              )}
            </Link>

            {Object.keys(teamState).length !== 0 &&
              !teamState?.manager?.avatar && (
                <span className="manegarNoProfilePicture">
                  <span className="manegarNoUserAvatar">
                    {teamState?.manager?.full_name.charAt(0).toUpperCase()}
                  </span>
                </span>
              )}
          </div>
          <div className="t-card-icons mw-20">
            <span>
              <Link
                style={{ color: "#575F6B" }}
                to={`/teams/${teamState.id}/todolist`}
              >
                <FontAwesomeIcon
                  style={svgStyle}
                  icon={faListUl}
                  className="mwh-16 mb-3"
                />
              </Link>
            </span>
            {[3, 2].includes(team?.role_id) ? (
              <span style={{ cursor: "pointer" }}>
                <InviteTeamMember teamName={team?.name} teamId={team?.id}>
                  <FontAwesomeIcon
                    icon={faUserPlus}
                    style={svgStyle}
                    className="mwh-16 mb-3"
                  />
                </InviteTeamMember>
              </span>
            ) : (
              <span></span>
            )}
            {[3, 2].includes(team?.role_id) ? (
              <span style={{ cursor: "pointer" }}>
                <TeamStatsDialog teamName={team?.name} teamId={team?.id}>
                  <FontAwesomeIcon
                    style={svgStyle}
                    icon={faChartBar}
                    className="mwh-16 mb-3"
                  />
                </TeamStatsDialog>
              </span>
            ) : (
              <span></span>
            )}
            <span>
              <Link
                style={{ color: "#575F6B" }}
                to={`/teams/${teamState.id}/info`}
              >
                <FontAwesomeIcon
                  style={svgStyle}
                  icon={faInfoCircle}
                  className="mwh-16 mb-3"
                />
              </Link>
            </span>
          </div>
          <div className="t-card-content" style={classes.teamContent}>
            <div className="team-title" style={classes.teamName}>
              {teamState.name}
            </div>
            <div className="teamText" style={classes.topicName}>
              <small className="fs-12 color-light teamText">
                {" "}
                {teamState.latest_topic
                  ? teamState.latest_topic.content
                  : "No current topics"}
              </small>
            </div>
            <div>
              <small>
                Role:{" "}
                <span style={{ fontWeight: "500" }}>{role[team?.role_id]}</span>
              </small>
            </div>
            <div className="joined-users">
              {teamState?.users?.map((user) => (
                <React.Fragment key={user?.id}>
                  <img
                    alt="user-name"
                    src={user?.avatar ?? UserDefaultAvatar}
                    className="stackedImage"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title={user?.full_name.toUpperCase()}
                  />
                </React.Fragment>
              ))}
              {teamState?.users_count > memberCount && (
                <span className="stackedImage userName">
                  <span className="userNoProfilePicture">
                    {" "}
                    +{teamState?.users_count - memberCount}{" "}
                  </span>
                </span>
              )}
            </div>
          </div>
          <Link
            style={{ color: "#575F6B" }}
            to={`/teams/${teamState.id}/timeline`}
          >
            <CustomButton
              type="button"
              name="Timeline"
              buttonClass="outline-btn f-left full_w"
            />
          </Link>
        </div>
      </div>
    </div>
  );
};
